module.exports = __webpack_public_path__ + "static/media/NCA c. 1910.b5a60f85.jpg";